/* istanbul ignore file */

import { useProgress } from '@react-three/drei';
import { useTranslation } from 'next-i18next';

export const Loader = () => {
  const { progress } = useProgress(state => state);
  const { t } = useTranslation(['free-form-hub/freeFormHubCommon']);
  return (
    <div
      data-testid="model-loader"
      className="absolute space-y-4 inset-0 flex flex-col items-center justify-center bg-gray-50 bg-opacity-90"
    >
      <div className="relative w-48 h-2 bg-gray-200 rounded-full overflow-hidden">
        <div
          className="absolute top-0 left-0 h-full bg-igus-primary transition-all duration-300 rounded-full"
          style={{ width: `${progress}%` }}
        />
      </div>
      <p className="text-sm text-gray-600 text-center">
        {t('COMMON.LOADING', { ns: 'free-form-hub/freeFormHubCommon' })} ({Math.round(progress)}%)
      </p>
    </div>
  );
};
